// @flow

import { createSelector } from 'reselect';

import {
  selectProducts,
  type DecoratedProduct,
  type ProductId,
} from '@gandi/cart';

import type { FullState } from '../../types';

export type SelectMailboxProductById = {
  id: ProductId,
};

export const selectMailboxProductById: (
  FullState,
  SelectMailboxProductById,
) => void | DecoratedProduct = createSelector(
  (state, props) => props,
  state => selectProducts(state),
  (props: SelectMailboxProductById, products: Array<DecoratedProduct>) =>
    products.find(product => product.id === props.id),
);
